import { createFileRoute } from '@tanstack/react-router'
import { Alvos } from '@/features/alvos/Alvos'

/** Plano de alvos, aba da ficha. A chave fica na ficha. */
export const Route = createFileRoute('/_app/app/p/$id/alvos')({
  component: function AlvosDoPaciente() {
    const { id } = Route.useParams()
    return <Alvos patientId={id} />
  },
})
